import * as React from 'react';
import { DialogContent, Typography } from '@mui/material';
import avatar from '../../../../assets/icons/avatar.svg';
import { errorNames } from '../../../../utils/constants';
import { handleChangeImage } from '../../../../utils/dragUtils/dragUtils';
import { ErrorText } from '../../../errorText/ErrorText';
import { UploadButtons } from '../controls/AvatarContols/AvatarContol';
import { ContactControl } from '../controls/ContactControls/ContactControl';
import { DescriptionControl } from '../controls/DescriptionContols/DescriptionControl';
import { GoalsAndCategoriesControl } from '../controls/GoalsAndCategoriesControls/GoalsAndCategoriesControl';
import { useStyles } from '../modalEditProfile.styles';
import { IPropsContactControl } from '../types';

export const Form = (props: IPropsContactControl): JSX.Element => {
  const classes = useStyles();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const {
    croppedImage,
    setCroppedImage,
    setUploadVisible,
    errors,
    setImage,
    register,
    required,
    goals,
    submitted,
    category,
    setGoals,
    setCategory,
    setValue,
    setAddress,
    address,
    control,
  } = props;

  const changeImageHandler = (e: React.ChangeEvent<HTMLInputElement>):void => {
    handleChangeImage({ e, setImage });
    setUploadVisible(true);
  };

  const handleUpload = (): void => {
    inputRef && inputRef.current?.click();
  };

  const uploadButtonsProps = {
    setImage,
    inputRef,
    handleUpload,
    croppedImage,
    setCroppedImage,
    setUploadVisible,
    changeImageHandler,
  };
  const goalAndCategoryProps = {
    goals,
    category,
    setGoals,
    setCategory,
    errors,
    register,
    required,
    control,
  };

  return (
    <DialogContent>
      <Typography
        gutterBottom
        className={classes.modalTitle}
      >
        Organisation details
      </Typography>
      <div className={classes.modalHeader}>
        <div>
          <img src={croppedImage || avatar} alt="" className={classes.croppedImage} />
        </div>
        <UploadButtons {...uploadButtonsProps} />
      </div>
      <div className={classes.errors}>
        {submitted && croppedImage === '' && <ErrorText text={errorNames.imageRequired} />}
      </div>
      <ContactControl
        errors={errors}
        register={register}
        required={required}
        setValue={setValue}
        setAddress={setAddress}
        address={address}
        control={control}
      />
      <GoalsAndCategoriesControl {...goalAndCategoryProps} />
      <DescriptionControl
        control={control}
        register={register}
        required={required}
        errors={errors}
      />
    </DialogContent>
  );
};
